import { FDBodyText } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';

const BodyText = (props) => {
  const {
    alignSelf,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    onBlur,
    onChange,
    min,
    max,
    onFocus,
    placeholder,
    readonly,
    required,
    size,
    value,
    ...rest
  } = props;

  return (
    <FDBodyText
      {...useDataAttrs(rest)}
      alignSelf={alignSelf}
      disabled={disabled || readonly}
      error={error}
      minLength={min}
      maxLength={max}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur}
      onChange={(val) => (val === undefined ? onChange('') : onChange(val))}
      onFocus={onFocus}
      placeholder={placeholder}
      required={required}
      size={size}
      value={value === '' ? undefined : value}
    />
  );
};

BodyText.defaultProps = {
  align: inputDefaultProps.align,
};

BodyText.propTypes = {
  align: inputPropTypes.align,
  size: inputPropTypes.size.isRequired,
  value: inputPropTypes.value.isRequired,
};

/**
 * @deprecated Renamed for consistency. Please use BodyTextMedium from ./Text instead.
 */
const BodyTextMedium = (props) => {
  return <FDBodyText {...props} size="md" />;
};

/**
 * @deprecated Renamed for consistency. Please use BodyTextLarge from ./Text instead.
 */
const BodyTextLarge = (props) => {
  return <FDBodyText {...props} size="lg" />;
};

/**
 * @deprecated Renamed for consistency. Please use BodyTextSmall from ./Text instead.
 */
const BodyTextSmall = (props) => {
  return <FDBodyText {...props} size="sm" />;
};

export { BodyTextMedium, BodyTextLarge, BodyTextSmall };
